export const SET_MESSAGE = 'SET_MESSAGE'
export const EMPTY_MESSAGE = 'EMPTY_MESSAGE'

export const SHOW_POPUP = 'SHOW_POPUP'
export const HIDE_POPUP = 'HIDE_POPUP'

export const SHOW_POPUP_WITH_INPUT = 'SHOW_POPUP_WITH_INPUT';
export const HIDE_POPUP_WITH_INPUT = 'HIDE_POPUP_WITH_INPUT';

export const SHOW_POPUP_WITH_SELECTBOX = 'SHOW_POPUP_WITH_SELECTBOX';
export const HIDE_POPUP_WITH_SELECTBOX = 'HIDE_POPUP_WITH_SELECTBOX';

export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_UPDATE = 'AUTH_UPDATE'
export const AUTH_OPERATOR_UPDATE = 'AUTH_OPERATOR_UPDATE';

export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'

export const SET_SETTING = 'SET_SETTING'
export const RESET_SETTINGS = 'RESET_SETTINGS'
export const SET_OWNER_SETTING = 'SET_OWNER_SETTING'

export const SET_LANGUAGE = 'SET_LANGUAGE'

export const SET_NAVIGATION_OPENED = 'SET_NAVIGATION_OPENED'
export const SET_NAVIGATION_CLOSED = 'SET_NAVIGATION_CLOSED'

export const SET_CHANNELS_DATA = 'SET_CHANNELS_DATA';

export const EPG_TAGS = 'EPG_TAGS';
export const EPG_COUNTRIES = 'EPG_COUNTRIES';




// WEBPACK FOOTER //
// ./src/store/mutation-types.js